import styled from 'styled-components';
export const ClosedButtons = styled.div`
  display: flex;
  align-items: center;

  > div {
    margin-right: 14px;
  }
`;
export const CopyButtons = styled.div`
  justify-content: space-between;
  display: flex;
  align-items: flex-start
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  width: 100%;
`;